<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="create()">Create Operator</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Operators..."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>


    <span class="show-inactive-span">Show Inactive</span>
    <label class="switch show-inactive-switch">
    <input
        id="showInactiveServices"
        type="checkbox" class="form-control"
        [(ngModel)]="showInactive"
        (change)="toggleShowInactive();">
    <span class="slider round"></span>
    </label>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
    #packageTable
    class='material striped datatable'
    [rows]='displayOperators'
    [columnMode]='"force"'
    [headerHeight]='40'
    [sorts]="[{prop: 'operatorId', dir: 'desc'}]"
    [footerHeight]='20'
    [scrollbarH]="true"
    [scrollbarV]="true"
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Operator Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="email" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Email
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.email}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="username" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Username
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.username}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="description" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Phone Number
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.phoneNumber}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="dateCreated" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Date Created
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.dateCreated | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false" [minWidth]="110" [maxWidth]="110">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Guest Account
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.guest ? 'Yes' : 'No'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false" [minWidth]="75" [maxWidth]="75">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Verified
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.verified ? 'Yes' : 'No'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="false" [minWidth]="75" [maxWidth]="75">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Station
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button
                placement="left"
                container="body"
                *ngIf="row.guest"
                tooltip="Guest accounts are assigned to all stations at their assigned location"
                style="color: white;"
                class="btn btn-info btn-icon">
                <i class="flaticon-exclamation-2"></i>
            </button>
            <button
                placement="left"
                container="body"
                *ngIf="(!row.stationId || row.stationId < 1) && !row.guest"
                tooltip="Click to assign this operator to a station"
                style="color: white;"
                class="btn btn-warning btn-icon"
                (click)="openStationLinkModal(row)">
                <i class="flaticon-warning-2"></i>
            </button>
            <button
                placement="left"
                container="body"
                *ngIf="row.stationId > 0 && !row.guest"
                tooltip="Click to reassign this operator to another station"
                style="color: white;"
                class="btn btn-success btn-icon"
                (click)="openStationLinkModal(row)">
                <i class="flaticon-interface-5"></i>
            </button>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button tooltip="Delete" style="float: right;" class="btn btn-danger btn-icon" *ngIf="row.active" (click)="delete(row.operatorId)"><i class="flaticon-cancel"></i></button>
            <button tooltip="Reactivate" style="float: right;" class="btn btn-warning btn-icon" *ngIf="!row.active" (click)="reactivate(row.operatorId)"><i class="flaticon-refresh"></i></button>
            <button tooltip="Edit" style="float: right;" class="btn btn-success btn-icon" (click)="edit(row.operatorId)"><i class="flaticon-edit-1"></i></button>
            <button tooltip="Resend Invite" style="float: right;" class="btn btn-info btn-icon" *ngIf="!row.verified" (click)="resentInvite(row.operatorId)"><i class="flaticon-paper-plane"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
